/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "./header/Header";
import { HeaderType, SETUP_FLOW } from "../vars";
import Secure from "../assets/icons/secure";
import Gdpr from "../assets/icons/gdpr";
import Access from "../assets/icons/access";
import SpecificButton from "./specificButton/SpecificButton";
import useIsCustom from "../customHook/useIsCustom";
import { convertToCentimeters, handlePostHogCustomEvent, handlePostUserDetails,  } from "../utils/util";
import { UserDetailsContext } from "../context/userDetails";

function Privacy() {
	const [isTermChecked, setIsTermChecked] = useState(false);
	const [isMuseChecked, setIsMuseChecked] = useState(false);
	const { email, gender, name, userInfo,shopDomain } = useContext(UserDetailsContext);
	
	const isCustom = useIsCustom();
	const navigate = useNavigate();
	const handlePostUser = async () => {
		const data = {
				email,
				username: name,
				attributes: {
					gender,
					height: userInfo?.height?.cm || convertToCentimeters(userInfo?.height?.ft, userInfo?.height?.inch),
				},
			};
		try {
			await handlePostUserDetails(data);
			handlePostHogCustomEvent(`${shopDomain}/userInfoUpdate`, { email, data: JSON.stringify(data), type: "success" });
		} catch (error) {
			console.log(error);
			handlePostHogCustomEvent(`${shopDomain}/userInfoUpdate`, { email, data: JSON.stringify(data), type: "error", error: JSON.stringify(error) });
		}
	};
	useEffect(() => {
		handlePostUser();
	}, []);

	return (
		<div className="h-full pt-4 px-4 flex flex-col w-full max-w-md mx-auto   bg-primary ">
			<div className="flex-1">
				<div>
					<Header hideSubHeading={false} heading=" " headerTop="logoOnlyLeft" whatTypeHeader={HeaderType.Deafult} />
				</div>
				<h2 className="text-center mt-4">Your Privacy</h2>
				<div className=" max-w-[380px] mx-auto  py-4">
					<p className="text-center max-w-[360px] mx-auto text-sm">
						{isCustom
							? "To take your measurements, you will be asked to scan your body. Here’s how we protect your data"
							: `To create your Muse, you will be asked to scan your face and body. Here’s how we protect your data`}
						:
					</p>
					<div className="flex gap-6 mt-8 items-center max-w-[320px] mx-auto">
						<div className="w-[40px] [&>svg]:w-[40px] [&>svg]:h-[40px]">
							<Access />
						</div>{" "}
						<p>
							<strong className="font-semibold">{isCustom ? "Your measurements are yours." : "Your Muse is yours."}</strong>
							<br />
							{isCustom ? "Only you or a brand with permission can access them" : "Only you can access or delete it"}.
						</p>
					</div>
					<div className="flex gap-6 mt-8 items-center max-w-[320px] mx-auto">
						<div className="w-[40px] [&>svg]:w-[40px] [&>svg]:h-[40px]">
							<Secure />
						</div>{" "}
						<p>
							{" "}
							<strong className="font-semibold">We never sell your data.</strong>
							<br /> Not to anyone, ever.
						</p>
					</div>
					<div className="flex gap-6 mt-8 items-center max-w-[320px] mx-auto">
						<div className="w-[40px] [&>svg]:w-[40px] [&>svg]:h-[40px]">
							<Gdpr />
						</div>{" "}
						<p>
							{" "}
							<strong className="font-semibold">
								Everything is encrypted & <br /> GDPR-compliant.
							</strong>
							<br />
						</p>
					</div>
				</div>
				<p className="mt-6  font-semibold border-t max-w-[320px] mx-auto  border-[#25333A] pt-6">To proceed, we need your permission:</p>
				<div className="mt-6  max-w-[320px] mx-auto">
					<FormControlLabel
						control={<Checkbox checked={isMuseChecked} onChange={() => setIsMuseChecked(!isMuseChecked)} />}
						label={
							<div className="text-[14px]">
								{isCustom ? "I agree to the processing of my body scan data to take my measurements." : `I agree to the processing of my face and body scan data to create my Muse.`}
							</div>
						}
					/>
				</div>
				<div className="mt-6  max-w-[320px] mx-auto">
					<FormControlLabel
						control={<Checkbox checked={isTermChecked} onChange={() => setIsTermChecked(!isTermChecked)} />}
						label={
							<div className="text-[14px]">
								I’ve read and agree to Swan’s{" "}
								<a className="underline" href="https://swan.so/privacy" target="_blank" rel="noreferrer">
									Privacy Policy
								</a>{" "}
								and{" "}
								<a className="underline" href="https://swan.so/terms" target="_blank" rel="noreferrer">
									Terms of Service
								</a>
								.
							</div>
						}
					/>
				</div>
			</div>
			<div className="flex justify-center px-4 pt-4 pb-5">
				<SpecificButton disabled={!isMuseChecked || !isTermChecked} btnSecondary buttonText="Continue" buttonFunc={() => navigate(SETUP_FLOW)} />
			</div>
		</div>
	);
}

export default Privacy;
